import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth/constants/AuthConstants';
import {TEEN_REVIEW_DETAIL_EVENTS} from '@/app/auth/events/TeenReviewDetailEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackSelectAddKidEditInfo = useCallback(
    (noPhone: boolean, themeSelected: string, parentId: string) => {
      trackEvent(TEEN_REVIEW_DETAIL_EVENTS.SELECT_ADD_KID_EDIT_INFO, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          role: RolesAccount.PARENT,
          id: parentId,
        },
        Banking: {
          card: {
            theme: {
              name: themeSelected,
            },
          },
        },
        FamilyMember: {
          no_phone: noPhone,
        },
      });
    },
    [trackEvent],
  );

  const trackViewAddKidConfirmInfo = useCallback(
    (noPhone: boolean, themeSelected: string, parentId: string) => {
      trackEvent(TEEN_REVIEW_DETAIL_EVENTS.VIEW_ADD_KID_CONFIRM_INFO, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          role: RolesAccount.PARENT,
          id: parentId,
        },
        Banking: {
          card: {
            theme: {
              name: themeSelected,
            },
          },
        },
        FamilyMember: {
          no_phone: noPhone,
        },
      });
    },
    [trackEvent],
  );

  const trackSelectAddKidConfirmEditInfo = useCallback(
    (noPhone: boolean, themeSelected: string, parentId: string) => {
      trackEvent(TEEN_REVIEW_DETAIL_EVENTS.SELECT_ADD_KID_CONFIRM_EDIT_INFO, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          role: RolesAccount.PARENT,
          id: parentId,
        },
        Banking: {
          card: {
            theme: {
              name: themeSelected,
            },
          },
        },
        FamilyMember: {
          no_phone: noPhone,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackSelectAddKidEditInfo,
    trackViewAddKidConfirmInfo,
    trackSelectAddKidConfirmEditInfo,
  };
};
